<template>
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <circle cx="8" cy="10" r="8" fill="currentColor" />
    </svg>
</template>
